export default __webpack_public_path__ + "static/topo-projects-48cc0096f33e7aa83ef5af6d5d760e35.png";